import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import { init } from 'echarts';

import { reverse } from 'lodash';
import Color from '@/tool/color';
import Empty from '@/component/empty';
import moIndex from '../../store';
import moWelfare from '../store';

interface IProps {}
interface IState {}

const Human = (props: IProps, state: IState) => {
  const hummerRef = useRef<any>(null);
  let echartdom: any = null;
  const { KeyFestivalsDate, KeyFestivalsList } = moWelfare;
  const { isMock } = moIndex;

  const getHeightData = () => {
    const list: any = [];
    KeyFestivalsDate?.forEach((item: any) => {
      list.push(item.data[2].rate);
    });
    return list;
  };

  const getMiddleData = () => {
    const list: any = [];
    KeyFestivalsDate?.forEach((item: any) => {
      list.push(item.data[1].rate);
    });
    return list;
  };

  const getLowData = () => {
    const list: any = [];
    KeyFestivalsDate?.forEach((item: any) => {
      list.push(item.data[0].rate);
    });
    return list;
  };

  const colorList = [Color.primary, Color.two, Color.warning];

  const render = () => {
    if (echartdom) echartdom.dispose();
    echartdom = init(hummerRef.current);
    const option = {
      color: colorList,
      grid: {
        top: 20,
        right: 10,
        bottom: 60,
        left: 50,
      },
      legend: {
        type: 'plain',
        data: reverse(['75分位', '50分位', '25分位']),
        bottom: 10,
        icon: 'roundRect',
        selectedMode: false,
        itemWidth: 8,
        itemHeight: 8,
        textStyle: {
          color: Color.c87,
          fontSize: 12,
        },
      },
      xAxis: {
        type: 'category',
        // boundaryGap: false,
        data: KeyFestivalsList,
        axisLine: {
          show: true,
          lineStyle: {
            color: Color.ccc,
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: true,
          color: Color.blackColor(0.85),
          fontFamily: 'Roboto',
          fontSize:12,
        },
      },
      yAxis: {
        type: 'value',
        splitLine: {
          show: true,
          lineStyle: {
            color: Color.blackColor(0.1),
            width: 1,
            type: 'dashed',
          },
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: Color.ccc,
          },
        },
        axisTick: {
          show: true,
          lineStyle: {
            color: Color.ccc,
          },
        },
        axisLabel: {
          show: true,
          interval: 'auto',
          color: Color.blackColor(0.5),
          fontFamily: 'Roboto',
          fontSize:12,
        },
      },
      series: [
        {
          name: '75分位',
          type: 'scatter',
          data: getHeightData(),
          symbolSize: 15,
        },
        {
          name: '50分位',
          type: 'scatter',
          data: getMiddleData(),
          symbolSize: 15,
        },
        {
          name: '25分位',
          type: 'scatter',
          data: getLowData(),
          symbolSize: 15,
        },
      ],
    };
    echartdom.setOption(option);
  };

  useEffect(() => {
    if (hummerRef.current) {
      render();
    }
    return () => {};
  }, [KeyFestivalsDate]);

  useEffect(() => {
    window.addEventListener('resize', render);
    return () => {
      window.removeEventListener('resize', render);
    };
  });

  return KeyFestivalsDate.length > 0 ? (
    <section
      className='holiday-svg-warp'
      ref={hummerRef}
      style={{
        width: '100%',
        height: '350px',
        marginBottom: 30,
        backgroundImage: isMock ?
          'url(https://file.smartsalary.cn/web-img%402.0/market/image/ismock.png)' :
          '',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
      }}/>
  ) : (
    <Empty />
  );
};

export default observer(Human);
